const dynamicPackage = {
  detailedPlan: "Plan detallado", // translated
  minimum: "Mínimo", // translated
  maximum: "Máximo", // translated
};

export default dynamicPackage;
